<template lang="pug">
aiq-dropdown.full-width(placement="top-end",
                        :hide-timeout="5"
                        class="mt-1"
                        popper-class="quick-response-dropdown"
                        @visible-change="handleVisibleChange")
  template(v-slot:dropdown)
    aiq-dropdown-menu.context-menu.custom-notes-menu
      aiq-dropdown-item.context-menu-item(key="edit", command="edit")
        aiq-tooltip(effect="dark", placement="top", :content="$t('global.edit')", :show-after="500")
          .menu-item-icon(@click="$emit('editMode', note);")
            i(class="el-icon-edit")
      aiq-dropdown-item.context-menu-item(key="delete", command="delete")
        aiq-tooltip(effect="dark", placement="top", :content="$t('global.delete')", :show-after="500")
          .menu-item-icon(@click="$emit('remove', note)")
            i(class="el-icon-delete")
  .note
    aiq-tooltip(effect="dark"
                placement="left"
                :content="normalizedContent"
                raw-content
                popper-class="rich-text-tooltip"
                :show-after="500")
      .note-content-container(:class="{is_expired: isExpired && featureFlags.NOTES_EXIPRATION}")
        .note_content(v-html="normalizedContent")
    .note-metadata {{ metadata }}
</template>

<script>
import dayjs from '@/localPlugins/dayjs';
import { normalizeEmptyParagraphs } from '@/libs';
import get from 'lodash/get';
import { mapState } from 'vuex';

export default {
  inject: ['focusOnInputbox'],
  computed: {
    ...mapState({
      featureFlags: state => state.featureFlags.FEATURE_FLAGS,
    }),
    normalizedContent() {
      return normalizeEmptyParagraphs(this.note.content);
    },
    metadata() {
      const basePath = 'conversation_tab.side_panel.customer_info_accordion.customer_notes';
      const createdAt = dayjs(this.note.created_at).format('MMM DD, YYYY hh:mm A');
      return this.note.agent
        ? this.$t(`${basePath}.note_added_by_agent`, {
          agent_name: `${this.note.agent.profile.first_name} ${this.note.agent.profile.last_name}`,
          date: createdAt,
        })
        : this.$t(`${basePath}.note_added_by_import`, { date: createdAt });
    },
    isExpired() {
      const expireAt = get(this.note, 'expire_at', null);
      if (!expireAt) return false;
      return dayjs(expireAt).isBefore(dayjs(), 'day');
    },
  },
  props: {
    note: {
      type: Object,
      required: true,
    },
  },
  emits: ['editMode', 'remove'],
  methods: {
    handleVisibleChange(isVisible) {
      if (!isVisible) {
        this.focusOnInputbox();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../../../../../styles/aiq-variables.scss";
@import "./../../../../../../styles/aiq-mixins.scss";
.full-width {
  width: 100%;
}

.el-icon-edit {
  margin-left: 0;
}

.note {
  .note-content-container {
    position: relative;
    padding: 10px 10px 10px 10px;
    margin-top: 8px;
    color: #F9FAFC;
    font-size: 11px;
    line-height: 13px;
    font-weight: 300;
    border-radius: 4px;
    background-color: #414246;

    &.is_expired {
      opacity: 0.7;
    }

    &:hover {
      box-shadow: 0 0 2px 0 rgba(50,64,87,0.90);
      background-color: #66676a;
    }

    .note_content {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      color: #fff;

      :deep(a) {
        color: var(--el-color-primary-light-3) !important;
        pointer-events: none;
        text-decoration: underline !important;
      }
      :deep(h1) {
        line-height: 1.5rem;
        color: #fff !important;
      }
      :deep(h2) {
        line-height: 1.4rem;
        color: #fff !important;
      }
      :deep(h3) {
        line-height: 1.3rem;
        color: #fff !important;
      }
      :deep(h4) {
        line-height: 1.2rem;
        color: #fff !important;
      }
      :deep(h5) {
        line-height: 1.1rem;
        color: #fff !important;
      }
      :deep(h6) {
        line-height: 1.0em;
        color: #fff !important;
      }

      :deep(p) {
        color: #fff !important;
      }
      @include list-reset;
    }
  }
}



.note-metadata {
    margin-top: 2px;
    color: $aiq-text-conversation-info-notes-item-dage;
    font-size: 10px;
    line-height: 10px;
  }

ul.custom-notes-menu.el-zoom-in-top-leave-active {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;
}
</style>
